import { createContext, useContext, useState } from 'react';

const translations = {
  fr: {
    // Home page
    heroTitle: "Découvre ta voie",
    heroSubtitle: "Un test Ikigai de 3 minutes pour explorer les carrières qui te correspondent",
    startButton: "Commencer le test",
    learnMore: "En savoir plus",
    whatIsIkigai: "Qu'est-ce que l'Ikigai ?",
    ikigaiDescription: "L'Ikigai est un concept japonais qui signifie 'raison d'être'. Il se trouve à l'intersection de ce que tu aimes, ce que tu sais faire, ce dont le monde a besoin, et ce pour quoi tu peux être payé(e).",
    passion: "Passion",
    passionDesc: "Ce que tu adores faire",
    talent: "Talent",
    talentDesc: "Ce que tu sais bien faire",
    mission: "Mission",
    missionDesc: "Ce dont le monde a besoin",
    profession: "Profession",
    professionDesc: "Ce pour quoi tu peux être payé(e)",
    howItWorks: "Comment ça marche ?",
    step1: "Réponds à 20 questions",
    step1Desc: "5 questions par catégorie Ikigai",
    step2: "Analyse tes résultats",
    step2Desc: "Découvre tes domaines de prédilection",
    step3: "Explore des carrières",
    step3Desc: "Reçois des suggestions de métiers en Belgique",
    duration: "Durée : ~3 minutes",
    targetAge: "Pour les 15-25 ans",
    
    // Questionnaire
    question: "Question",
    of: "sur",
    next: "Suivant",
    previous: "Précédent",
    seeResults: "Voir mes résultats",
    other: "Autre",
    otherPlaceholder: "Ta réponse personnelle...",
    category: "Catégorie",
    
    // Results page
    yourResults: "Tes résultats",
    domainScores: "Scores par domaine",
    careerSuggestions: "Métiers suggérés",
    saveResults: "Recevoir mes résultats par email",
    downloadPdf: "Télécharger en PDF",
    downloadImage: "Télécharger en image",
    retakeTest: "Refaire le test",
    backHome: "Retour à l'accueil",
    emailPlaceholder: "Ton adresse email",
    save: "Envoyer",
    savedSuccess: "Email envoyé !",
    match: "Correspondance",
    
    // Domains - 10 domaines
    domains: {
      social: "Social",
      education: "Enseignement",
      health: "Santé",
      creativity: "Créativité",
      technology: "Technologie",
      technical: "Métiers techniques",
      science: "Science",
      business: "Business",
      administration: "Gestion & Organisation",
      sports: "Sports"
    },
    
    // Footer
    inspireTagline: "Inspirer et outiller les talents de demain",
    
    // Misc
    loading: "Chargement...",
    backToDeclic: "Retour page principale Déclic",
    
    // Step Indicators - NEW
    stepIndicator: {
      step1Title: "Étape 1 sur 2 : Découverte de ton profil",
      step2Title: "Étape 2 sur 2 : Exploration des métiers",
      progress: "Tu es à {percent}% du parcours",
      step1Complete: "🎯 Tu as découvert ton profil !",
      step2Invitation: "👉 Passe à l'étape 2 pour découvrir les métiers qui te correspondent vraiment.",
      step2Benefits: "Dans la prochaine étape, tu vas :",
      benefit1: "Comparer différents métiers",
      benefit2: "Affiner tes résultats",
      benefit3: "Mieux comprendre ce qui te correspond",
      continueToStep2: "Continuer vers l'étape 2",
      fullResultsMessage: "Les résultats complets sont disponibles à l'étape 2."
    },
    
    // Stage 2 Exploration
    stage2: {
      title: "Affine ton choix",
      subtitle: "Réponds à 7 questions pour découvrir le métier qui te correspond le mieux",
      selectCareers: "Sélectionne 2 ou 3 métiers à explorer",
      selectedCount: "sélectionné(s)",
      minSelection: "Sélectionne au moins 2 métiers",
      maxSelection: "Tu peux sélectionner maximum 3 métiers",
      startExploration: "Commencer l'exploration",
      question: "Question",
      of: "sur",
      next: "Suivant",
      previous: "Précédent",
      seeResults: "Voir mon classement",
      yourRanking: "Ton classement personnalisé",
      topMatch: "Meilleure correspondance",
      whyThisMatch: "Pourquoi ce métier ?",
      backToResults: "Retour aux résultats",
      retakeStage2: "Refaire l'exploration",
      duration: "~2 minutes",
      // NEW: Similar careers indicator
      similarCareersDetected: "Ces métiers sont souvent confondus",
      questionsHelp: "Ces questions t'aideront à mieux distinguer",
      specificQuestions: "Questions ciblées pour toi"
    },
    
    // Stage 2 Results - NEW
    stage2Results: {
      profileTitle: "Ton Profil Déclic",
      topDomains: "Domaines dominants détectés pendant le test",
      careerRanking: "Classement de tes métiers",
      basedOnAnswers: "En fonction de tes réponses, ces métiers correspondent particulièrement à ton profil.",
      whyTopCareer: "Pourquoi ce métier te correspond",
      exploreInRealLife: "Passe à l'action !",
      exploreMessage: "L'outil Déclic ne se limite pas à proposer des métiers : il encourage les jeunes à découvrir concrètement ces professions et à rencontrer des professionnels.",
      exploreAdvice: "Cela se fait notamment à travers les rencontres que nous organisons dans le cadre du Parcours Déclic, de Déclic@School et de la Journée Déclic.",
      declicEvents: "Découvre les activités Déclic",
      declicEventsMessage: "Tu peux rencontrer des professionnels lors des activités Déclic, comme la Journée Déclic. C'est une excellente occasion de découvrir concrètement les métiers et de poser toutes tes questions.",
      discoverActivities: "Découvrir les activités",
      testMadeOn: "Test réalisé sur",
      revealPotential: "Révèle ton potentiel",
      // Career discovery section
      careerDiscovery: "Découvre ce métier",
      typicalTasks: "Tâches typiques",
      usefulSkills: "Compétences utiles",
      studiesInBelgium: "Études en Belgique",
      workEnvironment: "Environnement de travail",
      salaryRange: "Fourchette salariale",
      // Labour market section
      labourMarket: "Ce métier sur le marché du travail",
      marketDemand: "Demande du marché",
      shortage: "Métier en pénurie",
      concernedRegions: "Régions concernées",
      trend: "Tendance",
      source: "Source",
      // Post-test questions
      postTestTitle: "Une dernière question",
      postTestQuestion: "Après avoir complété ce test, comment te sens-tu par rapport à tes idées de métier ?",
      postTestAnswers: {
        discovered_new: "J'ai découvert de nouveaux métiers",
        confirmed_idea: "J'ai confirmé une idée que j'avais déjà",
        new_directions: "J'ai maintenant de nouvelles pistes à explorer",
        still_reflecting: "Je réfléchis encore"
      },
      engagementTitle: "Ce test me donne envie de :",
      engagementAnswers: {
        meet_professional: "Rencontrer un(e) professionnel(le)",
        explore_training: "Explorer des programmes de formation",
        discuss_advisor: "Discuter avec un(e) enseignant(e) ou conseiller(ère)",
        continue_exploring: "Continuer à explorer les métiers"
      },
      skipQuestion: "Passer",
      submitFeedback: "Terminer"
    }
  },
  nl: {
    // Home page
    heroTitle: "Ontdek je pad",
    heroSubtitle: "Een Ikigai-test van 3 minuten om carrières te verkennen die bij je passen",
    startButton: "Start de test",
    learnMore: "Meer info",
    whatIsIkigai: "Wat is Ikigai?",
    ikigaiDescription: "Ikigai is een Japans concept dat 'reden van bestaan' betekent. Het bevindt zich op het kruispunt van wat je graag doet, wat je goed kunt, wat de wereld nodig heeft, en waarvoor je betaald kunt worden.",
    passion: "Passie",
    passionDesc: "Wat je graag doet",
    talent: "Talent",
    talentDesc: "Waar je goed in bent",
    mission: "Missie",
    missionDesc: "Wat de wereld nodig heeft",
    profession: "Beroep",
    professionDesc: "Waarvoor je betaald kunt worden",
    howItWorks: "Hoe werkt het?",
    step1: "Beantwoord 20 vragen",
    step1Desc: "5 vragen per Ikigai-categorie",
    step2: "Analyseer je resultaten",
    step2Desc: "Ontdek je voorkeurdomeinen",
    step3: "Verken carrières",
    step3Desc: "Ontvang suggesties voor beroepen in België",
    duration: "Duur: ~3 minuten",
    targetAge: "Voor 15-25 jarigen",
    
    // Questionnaire
    question: "Vraag",
    of: "van",
    next: "Volgende",
    previous: "Vorige",
    seeResults: "Bekijk mijn resultaten",
    other: "Anders",
    otherPlaceholder: "Jouw persoonlijke antwoord...",
    category: "Categorie",
    
    // Results page
    yourResults: "Jouw resultaten",
    domainScores: "Scores per domein",
    careerSuggestions: "Voorgestelde beroepen",
    saveResults: "Ontvang mijn resultaten per e-mail",
    downloadPdf: "Download als PDF",
    downloadImage: "Download als afbeelding",
    retakeTest: "Test opnieuw doen",
    backHome: "Terug naar home",
    emailPlaceholder: "Je e-mailadres",
    save: "Verzenden",
    savedSuccess: "E-mail verzonden!",
    match: "Match",
    
    // Domains - 10 domeinen
    domains: {
      social: "Sociaal",
      education: "Onderwijs",
      health: "Gezondheid",
      creativity: "Creativiteit",
      technology: "Technologie",
      technical: "Technische beroepen",
      science: "Wetenschap",
      business: "Business",
      administration: "Administratie",
      sports: "Sport & Bien-être"
    },
    
    // Footer
    inspireTagline: "Inspireren en uitrusten van de talenten van morgen",
    
    // Misc
    loading: "Laden...",
    backToDeclic: "Terug naar hoofdpagina Déclic",
    
    // Step Indicators - NEW
    stepIndicator: {
      step1Title: "Stap 1 van 2: Ontdek je profiel",
      step2Title: "Stap 2 van 2: Verken de beroepen",
      progress: "Je bent {percent}% van het parcours",
      step1Complete: "🎯 Je hebt je profiel ontdekt!",
      step2Invitation: "👉 Ga naar stap 2 om de beroepen te ontdekken die echt bij je passen.",
      step2Benefits: "In de volgende stap ga je:",
      benefit1: "Verschillende beroepen vergelijken",
      benefit2: "Je resultaten verfijnen",
      benefit3: "Beter begrijpen wat bij je past",
      continueToStep2: "Doorgaan naar stap 2",
      fullResultsMessage: "De volledige resultaten zijn beschikbaar in stap 2."
    },
    
    // Stage 2 Exploration
    stage2: {
      title: "Verfijn je keuze",
      subtitle: "Beantwoord 7 vragen om te ontdekken welk beroep het beste bij je past",
      selectCareers: "Selecteer 2 of 3 beroepen om te verkennen",
      selectedCount: "geselecteerd",
      minSelection: "Selecteer minstens 2 beroepen",
      maxSelection: "Je kunt maximaal 3 beroepen selecteren",
      startExploration: "Start de verkenning",
      question: "Vraag",
      of: "van",
      next: "Volgende",
      previous: "Vorige",
      seeResults: "Bekijk mijn ranking",
      yourRanking: "Jouw gepersonaliseerde ranking",
      topMatch: "Beste match",
      whyThisMatch: "Waarom dit beroep?",
      backToResults: "Terug naar resultaten",
      retakeStage2: "Verkenning opnieuw doen",
      duration: "~2 minuten",
      // NEW: Similar careers indicator
      similarCareersDetected: "Deze beroepen worden vaak verward",
      questionsHelp: "Deze vragen helpen je om beter te onderscheiden",
      specificQuestions: "Gerichte vragen voor jou"
    },
    
    // Stage 2 Results - NEW
    stage2Results: {
      profileTitle: "Jouw Déclic Profiel",
      topDomains: "Dominante domeinen gedetecteerd tijdens de test",
      careerRanking: "Ranking van je beroepen",
      basedOnAnswers: "Op basis van je antwoorden passen deze beroepen bijzonder goed bij je profiel.",
      whyTopCareer: "Waarom dit beroep bij je past",
      exploreInRealLife: "Ga in actie!",
      exploreMessage: "De Déclic tool beperkt zich niet tot het voorstellen van beroepen: het moedigt jongeren aan om deze beroepen concreet te ontdekken en professionals te ontmoeten.",
      exploreAdvice: "Dit gebeurt onder andere via de ontmoetingen die we organiseren in het kader van het Déclic Parcours, Déclic@School en de Déclic Dag.",
      declicEvents: "Ontdek Déclic activiteiten",
      declicEventsMessage: "Je kunt professionals ontmoeten tijdens Déclic activiteiten, zoals de Déclic Dag. Dit is een uitstekende gelegenheid om beroepen concreet te ontdekken en al je vragen te stellen.",
      discoverActivities: "Ontdek activiteiten",
      testMadeOn: "Test gemaakt op",
      revealPotential: "Onthul je potentieel",
      // Career discovery section
      careerDiscovery: "Ontdek dit beroep",
      typicalTasks: "Typische taken",
      usefulSkills: "Nuttige vaardigheden",
      studiesInBelgium: "Studies in België",
      workEnvironment: "Werkomgeving",
      salaryRange: "Salarisschaal",
      // Labour market section
      labourMarket: "Dit beroep op de arbeidsmarkt",
      marketDemand: "Marktvraag",
      shortage: "Knelpuntberoep",
      concernedRegions: "Betrokken regio's",
      trend: "Trend",
      source: "Bron",
      // Post-test questions
      postTestTitle: "Een laatste vraag",
      postTestQuestion: "Na het voltooien van deze test, hoe voel je je over je beroepsideeën?",
      postTestAnswers: {
        discovered_new: "Ik heb nieuwe beroepen ontdekt",
        confirmed_idea: "Ik heb een idee bevestigd dat ik al had",
        new_directions: "Ik heb nu nieuwe richtingen om te verkennen",
        still_reflecting: "Ik denk nog na"
      },
      engagementTitle: "Deze test geeft me zin om:",
      engagementAnswers: {
        meet_professional: "Een professional te ontmoeten",
        explore_training: "Opleidingsprogramma's te verkennen",
        discuss_advisor: "Te praten met een leraar of adviseur",
        continue_exploring: "Beroepen te blijven verkennen"
      },
      skipQuestion: "Overslaan",
      submitFeedback: "Afronden"
    }
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('fr');
  
  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };
  
  const toggleLanguage = () => {
    setLanguage(prev => prev === 'fr' ? 'nl' : 'fr');
  };
  
  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
